import React from 'react';
import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
// import { Helmet } from 'react-helmet-async';



// const PulleyList = ({ pulleys }) => {

//     if (!pulleys) {
//         return <>입력된 Pulley가 없습니다.</>
//     }

//     const dataMap = {
//         id: 'ID',
//         beltWidth: 'Belt Width',
//         application: 'Pulley Application',
//         pulleyTypeCategory: 'Pulley Type Category',
//         numberOfPulley: "Q'ty",
//         resultantForce: 'Resultant Force (N)',
//         torque: 'Torque (N-cm)',
//         brgDistance: 'Bearing Center Distance (cm)',
//         webDistance: 'Pulley Web Distance (cm)',
//         momentArm: 'Moment Arm (cm)',
//         eccentricFactor: 'Eccentric Factor',
//         maxMoment: 'Max. Moment (N-cm)',
//         hubDiaByStress: 'Shaft Dia. @Hub by Stress (cm)',
//         hubDiaByDeflection: 'Shaft Dia @Hub by Def. (cm)',
//         hubDiaSelected: 'Shaft Dia. @Hub Selected (cm)',
//         minPulleyDia: 'Min. Pulley Dia. (mm)',
//         diaSelected: 'Pulley Dia. Selected (mm)',
//         laggingThick: 'Lagging Thickness (mm)',
//         diaWithLagging: 'Pulley Dia. with Lagging (mm)',
//         RPM: 'Pulley RPM',
//         brgDiaCalculated: 'Shaft Dia. @Brg. Center, Calculated (mm)',
//         brgDiaSelected: 'Shaft Dia. @BRG. Center, Selected (mm)',
//         plummerBlockNumber: 'Plummber Block No.',
//         plummerBlockWeight: 'Plummer Block Weight (kg)',
//         brgNumber: 'Bearing No.',
//         dynamicRating: 'Dynamic Rating (kN)',
//         lifeL10h: 'Bearing Life (L10h)',
//         pulleyTurningResistance: 'Pulley Turning Resistance (N)',
//         beltWrapResistance: 'Belt Wrap Resistance (N)',
//         pulleyWeight: 'Assumed Pulley Weight (kg)'
//     }

//     return (
//         <Table>
//             <thead></thead>
//             <tbody>
//                 <h3>Pulley Summary</h3>
//                 {Object.keys(pulleys[0]).map((key, index) => (
//                     <tr key={index}>
//                         <th>{dataMap[key]}</th>
//                         {pulleys.map((pulley, pulleyIndex) => (
//                             <td key={pulleyIndex}>{pulley[key]}</td>
//                         ))}
//                     </tr>
//                 ))}
//             </tbody>
//         </Table>
//     );
// };

const PulleySummary = ({ pulleys }) => {
    const dataMap = {
        application: 'Pulley Application',
        // id: 'ID',
        // beltWidth: 'Belt Width',
        pulleyTypeCategory: 'Pulley Type Category',
        numberOfPulley: "Q'ty",
        resultantForce: 'Resultant Force (N)',
        torque: 'Torque (N-cm)',
        eccentricFactor: 'Eccentric Factor',
        maxMoment: 'Max. Moment (N-cm)',
        brgDistance: 'Bearing Center Distance (cm)',
        webDistance: 'Pulley Web Distance (cm)',
        momentArm: 'Moment Arm (cm)',
        hubDiaByStress: 'Shaft Dia. @Hub by Stress (cm)',
        hubDiaByDeflection: 'Shaft Dia @Hub by Def. (cm)',
        hubDiaSelected: 'Shaft Dia. @Hub Selected (cm)',
        brgDiaCalculated: 'Shaft Dia. @Brg. Center, Calculated (mm)',
        brgDiaSelected: 'Shaft Dia. @BRG. Center, Selected (mm)',
        plummerBlockNumber: 'Plummber Block No.',
        plummerBlockWeight: 'Plummer Block Weight (kg)',
        brgNumber: 'Bearing No.',
        dynamicRating: 'Dynamic Rating (kN)',
        lifeL10h: 'Bearing Life (L10h)',
        minPulleyDia: 'Min. Pulley Dia. (mm)',
        diaSelected: 'Pulley Dia. Selected (mm)',
        laggingThick: 'Lagging Thickness (mm)',
        diaWithLagging: 'Pulley Dia. with Lagging (mm)',
        RPM: 'Pulley RPM',
        // pulleyTurningResistance: 'Pulley Turning Resistance (N)',
        // beltWrapResistance: 'Belt Wrap Resistance (N)',
        weight: 'Assumed Pulley Weight (kg)'
    }
    return (
        <PulleySummaryBlock>
            <Table>
                <thead></thead>
                <tbody>
                    <h3>Pulley Summary</h3>
                    {Object.keys(dataMap).map((key, index) => (
                        <tr key={index}>
                            <td className="title">{dataMap[key]}</td>
                            {pulleys && pulleys.map(pulley => (
                                <td key={pulley.id}>{pulley[key]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </PulleySummaryBlock>
    );
};

export default PulleySummary;


/* =================   Styles   ================== */
const PulleySummaryBlock = styled.div`
    width: 100%;
    // max-width: 1000px;
    // margin: 0 auto;
    margin-top: 2rem;
    margin-bottom: 5rem;
    td {
        padding: 0.125rem 0.5rem;
        width: 120px;
    }
    .title {
        text-align: left;
        width: 350px;
    }
`;

const Table = styled.table`
    // width: 100%;
    // max-width: 980px;
    // margin: 0 auto;
    border-collapse: collapse;

    td {
        // border-bottom: 1px solid ${palette.gray[4]};
        padding: 0.5rem 1.5rem;
        text-align: center;
        // max-width: 150px;
    }

    th {
        // background: ${palette.gray[7]};
        // color: white;
        padding: 0.25rem;
        border-bottom: 1px solid ${palette.gray[4]};
        font-weight: 550;
        padding-right: 2rem;
        text-align: left;
    }

    tr {
        &:hover {
            background-color: ${palette.gray[1]};
            transition: 0.3s;
        }
    }
`;